import { ChakraTheme } from "@chakra-ui/react";

const breakpoints: ChakraTheme["breakpoints"] = {
  base: "0em",
  sm: "34rem",
  md: "65rem",
};

export default breakpoints;
